import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import {
  ButtonSize,
  ButtonType,
  CSSProperties,
  ControlType,
  Link,
  UIEvent
} from '@com-delta-idp/mnx-ui-kit';
import { GenericLabel } from '@com-delta-idp/mnx-utils';
import { Orientation } from '../../pages/fast-action-banner-page/models/ui.interfaces';

@Component({
  selector: 'idp-offer-action-banner',
  templateUrl: './offer-action-banner.component.html',
  styleUrls: ['./offer-action-banner.component.scss'],
  encapsulation: ViewEncapsulation.None // added to update styles for child comp-standard-checkbox
})
export class OfferActionBannerComponent {
  @Input() backgroundColor = '';
  @Input() buttonLabel: string | undefined = '';
  @Input() buttonUrl: string | undefined = '';
  @Input() buttonId: string | undefined = '';
  @Input() secondaryLinkId: string | undefined = '';
  @Input() secondaryLink: Link | undefined = {} as Link;
  @Input() buttonLabelStyles: CSSProperties = {} as CSSProperties;
  @Input() inputType: ControlType = '' as ControlType;
  @Input() message: GenericLabel = {} as GenericLabel;
  @Input() enable = false;
  @Input() messageStyles: CSSProperties = {} as CSSProperties;
  @Input() orientation: Orientation = 'horizontal';
  @Input() actionSize!: ButtonSize;
  @Input() actionType!: ButtonType;
  @Input() axTitle = '';

  @Output() offerAction: EventEmitter<UIEvent> = new EventEmitter();
  @ViewChild('checkboxRef') checkboxRef!: {
    inputReference: ElementRef<HTMLInputElement>;
  };

  isChecked = false;

  offerActionFromButton(event: boolean) {
    const uiEvent: UIEvent = {
      target: 'button',
      value: event
    };

    this.offerAction.emit(uiEvent);
  }

  offerActionFromCheckbox(event: Event) {
    const checked = (event.target as HTMLInputElement).checked as boolean;
    this.isChecked = checked;

    const uiEvent: UIEvent = {
      target: 'checkbox',
      value: checked
    };

    this.offerAction.emit(uiEvent);
  }

  handleContainerClick() {
    if (this.inputType === 'checkbox') {
      this.isChecked = !this.isChecked;

      // Sync DOM element
      setTimeout(() => {
        if (this.checkboxRef?.inputReference?.nativeElement) {
          this.checkboxRef.inputReference.nativeElement.checked =
            this.isChecked;
        }
      }, 0);

      const uiEvent = {
        target: { checked: this.isChecked }
      } as Event & { target: HTMLInputElement };

      this.offerActionFromCheckbox(uiEvent);
    }
  }
}
